<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Representantes Cadastrados'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn color="primary" fab small dark @click="novoRepresentante"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>CPF/CNPJ</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="rep in representantes" :key="rep.id">
                  <td>{{ rep.id }}</td>
                  <td>{{ rep.nome }}</td>
                  <td>{{ rep.cpfcnpj }}</td>
                  <td align="center">
                    <v-btn
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(rep.id)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >&nbsp;
                    <v-btn
                      color="error"
                      fab
                      x-small
                      dark
                      @click="inativar(rep.id)"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";

export default {
  name: "representante",
  data() {
    return {
      representantes: [],
    };
  },
  components: {
    KTCodePreview,
  },
  methods: {
    novoRepresentante() {
      this.$router.push({ name: "representanteCadastro" });
    },

    listaRepresentantes() {
      return new Promise((resolve) => {
        ApiService.get("representante").then(({ data }) => {
          resolve(data);

          if (data.success) this.representantes = data.data;
          else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    editar(id) {
      this.$router.push({ path: "representante/cadastro/" + id });
    },

    inativar(id) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("representante/" + id + "/inativar").then(
              ({ data }) => {
                resolve(data);

                if (data.success === true) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Representante Inativado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.listaRepresentantes();
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Representantes" }]);
    this.listaRepresentantes();
  },
};
</script>
